import { JsonLd } from "react-schemaorg";
import type { NewsMediaOrganization } from "schema-dts";

import { config } from "shared/data";

export const renderPoliciesAndStandardsSchema = () => (
  <JsonLd<NewsMediaOrganization>
    item={{
      "@context": "https://schema.org",
      "@id": `${config.general.siteUrl}#organization`,
      "@type": "NewsMediaOrganization",
      actionableFeedbackPolicy: "https://www.scmp.com/policies-and-standards#engagement",
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "Newsroom Contact",
          email: "news@scmp.com",
          url: "https://www.scmp.com/contact-us",
        },
        {
          "@type": "ContactPoint",
          contactType: "Public Engagement",
          email: "letters@scmp.com",
          url: "https://www.scmp.com/contact-us",
        },
      ],
      correctionsPolicy: "https://www.scmp.com/policies-and-standards#corrections",
      diversityPolicy: "https://www.scmp.com/policies-and-standards#diverse-voices",
      diversityStaffingReport: "https://www.scmp.com/policies-and-standards#bestpractice",
      ethicsPolicy: "https://www.scmp.com/policies-and-standards#ethics",
      foundingDate: "1903-11-06",
      masthead: "https://corp.scmp.com/about-us/corporate-executives/",
      missionCoveragePrioritiesPolicy:
        "https://www.scmp.com/policies-and-standards#mission-statement",
      name: "South China Morning Post",
      ownershipFundingInfo: "https://www.scmp.com/policies-and-standards#ownership",
      unnamedSourcesPolicy: "https://www.scmp.com/policies-and-standards#unnamed",
      verificationFactCheckingPolicy: "https://www.scmp.com/policies-and-standards#verification",
    }}
  />
);

export const renderPromotionsTermsAndConditionsSchema = () => (
  <JsonLd<NewsMediaOrganization>
    item={{
      "@context": "https://schema.org",
      "@id": `${config.general.siteUrl}#organization`,
      "@type": "NewsMediaOrganization",
      actionableFeedbackPolicy: "https://www.scmp.com/policies-and-standards#engagement",
      contactPoint: [
        {
          "@type": "ContactPoint",
          contactType: "Newsroom Contact",
          email: "news@scmp.com",
          url: "https://www.scmp.com/contact-us",
        },
        {
          "@type": "ContactPoint",
          contactType: "Public Engagement",
          email: "letters@scmp.com",
          url: "https://www.scmp.com/contact-us",
        },
      ],
      correctionsPolicy: "https://www.scmp.com/policies-and-standards#corrections",
      diversityPolicy: "https://www.scmp.com/policies-and-standards#diverse-voices",
      diversityStaffingReport: "https://www.scmp.com/policies-and-standards#bestpractice",
      ethicsPolicy: "http://www.bbc.co.uk/editorialguidelines/guidelines",
      foundingDate: "1903-11-06",
      masthead: "https://corp.scmp.com/about-us/corporate-executives/",
      missionCoveragePrioritiesPolicy:
        "https://www.scmp.com/policies-and-standards#mission-statement",
      name: "South China Morning Post",
      ownershipFundingInfo: "https://www.scmp.com/policies-and-standards#ownership",
      unnamedSourcesPolicy: "https://www.scmp.com/policies-and-standards#unnamed",
      verificationFactCheckingPolicy: "https://www.scmp.com/policies-and-standards#verification",
    }}
  />
);
